import { render, staticRenderFns } from "./KlimaProductsComponent.vue?vue&type=template&id=222a4b02"
import script from "./KlimaProductsComponent.vue?vue&type=script&lang=js"
export * from "./KlimaProductsComponent.vue?vue&type=script&lang=js"
import style0 from "./KlimaProductsComponent.vue?vue&type=style&index=0&id=222a4b02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports